import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import { Modal } from 'react-bootstrap';
import { hideUMOModifyDialog } from '../../actions/mainUI';
import Button from '../ui/Button';
import { addIntlInfo } from '../../actions/messageDialog';
import ResizeDialog from './ResizeDialog';
import ZipDownloadDialog from './ZipDownloadDialog';
import PdfDownloadDialog from './PdfDownloadDialog';
import * as modTypes from '../../constants/umoModifications';
import { getWorkspaceDownloadOptions } from '../../actions/umoUtils';

const mapStateToProps = state => ({
  umoUtils: state.umoUtils,
  umoGallery: state.umoGallery,
});

const mapDispatchToProps = dispatch => ({
  hideUMOModifyDialog: () => dispatch(hideUMOModifyDialog()),
  addMessage: msgID => dispatch(addIntlInfo(msgID)),
  getDownloadOptions: workspaceID => dispatch(getWorkspaceDownloadOptions(workspaceID)),
});

class UMOModifyDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      isValid: false,
      error: null,
      isSuccess: false,
      type: '',
      width: 800,
      dpi: '',
      quality: 85,
      embedMeta: true,
      createDeriv: false,
    };

    this.onCloseClick = this.onCloseClick.bind(this);
    this.getViewByType = this.getViewByType.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.isShown !== prevProps.isShown && this.props.isShown) {
      this.props.getDownloadOptions(this.props.workspaceID);
    }
  }

  onCloseClick() {
    this.setState({
      isSubmitting: true,
    });
    this.props.hideUMOModifyDialog();
  }

  getViewByType() {
    const isSelectAll = this.props.umoGallery.get('isSelectAll');
    let view;
    switch (this.props.modType) {
      case modTypes.UMO_MODIFY_TYPE_RESIZE:
        view = (<ResizeDialog
          hideUMOModifyDialog={this.props.hideUMOModifyDialog}
          umoList={this.props.umoList}
          workspaceID={this.props.workspaceID}
          addMessage={this.props.addMessage}
          onCloseClick={this.onCloseClick}
          isSelectAll={isSelectAll}
        />);
        break;
      case modTypes.UMO_MODIFY_TYPE_ZIP_DOWNLOAD:
        view = (<ZipDownloadDialog
          hideUMOModifyDialog={this.props.hideUMOModifyDialog}
          umoList={this.props.umoList}
          workspaceID={this.props.workspaceID}
          addMessage={this.props.addMessage}
          onCloseClick={this.onCloseClick}
          downloadOptions={this.props.umoUtils.get('downloadOptions')}
          isSelectAll={isSelectAll}
        />);
        break;
      case modTypes.UMO_MODIFY_TYPE_PDF_DOWNLOAD:
        view = (<PdfDownloadDialog
          hideUMOModifyDialog={this.props.hideUMOModifyDialog}
          umoList={this.props.umoList}
          workspaceID={this.props.workspaceID}
          addMessage={this.props.addMessage}
          onCloseClick={this.onCloseClick}
          isSelectAll={isSelectAll}
        />);
        break;
      case modTypes.UMO_MODIFY_TYPE_CROP:
      case modTypes.UMO_MODIFY_TYPE_COPY:
      case modTypes.UMO_MODIFY_TYPE_ROTATE:
      default:
        break;
    }
    return view;
  }

  render() {
    const viewType = this.getViewByType();

    return (
      <div className="workspace-dialog">
        <Modal
          show={this.props.isShown}
          onHide={this.props.hideUMOModifyDialog}
          onExited={this.props.hideUMOModifyDialog}
          backdrop={this.state.isSubmitting ? 'static' : true}
          dialogClassName={classNames('workspace-dialog__overlay')}
        >
          <button
            onClick={this.onCloseClick}
            className="workspace-dialog__close-button"
          />
          {viewType}
        </Modal>
      </div>
    );
  }
}

UMOModifyDialog.propTypes = {
  isShown: PropTypes.bool,
  modType: PropTypes.string,
  umoList: PropTypes.instanceOf(Array),
  workspaceID: PropTypes.string,
  hideUMOModifyDialog: PropTypes.func,
  addMessage: PropTypes.func,
  getDownloadOptions: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(UMOModifyDialog));



// WEBPACK FOOTER //
// ./src/js/components/UMOModifyDialog/index.jsx